export default {

  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install (Vue, options) {
    const { toaster, dialogs } = options;
    // ES6 way of const job = options.job
    // Add $plugin instance method directly to Vue components
    Vue.prototype.$toaster = toaster;
    Vue.prototype.$dialogs = dialogs;
  }
};
